import { createContext } from 'react';
// Share posts already fetched by the vertical feed with the preview row.
export const FeedPreviewContext = createContext(null);
